var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('loader'),_c('go-top'),_c('top-bar'),_c('sidebar-nav'),_c('cart-mini-area'),_c('body-overlay'),(_vm.bDone)?_c('main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1):_vm._e(),_c('footer-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }